export const ingredientExtraPrices = {
  atun: 80,
  salmon: 90,
  kingCrab: 60,
  puerro: 20,
  aguacate: 40,
  platanoMaduro: 40,
};
